import styled from 'styled-components';

export const Menu = styled.div`
  margin: 0;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  background: #fff;
  margin-right: 50px;
  box-shadow:
    0px 1px 2px 0px rgba(0, 0, 0, 0.1),
    0px 1px 3px 0px rgba(0, 0, 0, 0.05);
`;

export const Item = styled.button`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  cursor: pointer;
  border-radius: 4px;
  width: 186px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  &.danger {
    color: #e03131;
  }

  &:hover {
    background: #f1f3f5;
  }
`;
